import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgEdit = ({ className, ...props }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    className={classNames('svg', 'svg-edit', className)}
    {...props}>
    <path
      className="svg__path svg-edit__path svg-edit__path--primary"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M0.5 20.5H4.5"
    />
    <path
      className="svg__path svg-edit__path svg-edit__path--primary"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.4235 5.10949L17.8644 8.10063"
    />
    <path
      className="svg__path svg-edit__path svg-edit__path--primary"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.55139 14.166L9.9923 17.1571"
    />
    <path
      className="svg__path svg-edit__path svg-edit__path--primary"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.52994 14.1583L15.6223 3.69871C16.5315 2.65281 18.1164 2.54198 19.1623 3.45117V3.45117C20.2082 4.36036 20.3191 5.94527 19.4099 6.99117L10.3175 17.4508L5.13868 19.6109L6.52994 14.1583Z"
    />
  </svg>
);

SvgEdit.propTypes = {
  className: PropTypes.string,
};

export default SvgEdit;
